import { IMsFormFilter } from "../types";

export const MS_FILTER_DEFAULTS: IMsFormFilter = {
    countries: null,
    regions: [],
    cities: [],
    types: [],
    clusters: [],
}